import { Box, Flex } from '@chakra-ui/react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminSideBar from '../Components/AdminSideBar';
import UserManagement from '../Admin/UserManagement';
import BatchManagement from '../Admin/BatchManagement';
import RegisterEnrolledStudent from '../Admin/RegisterEnrolledStudent';
import ReviewEnrolment from '../Admin/ReviewEnrolment';
import CourseManager from '../Common/CourseManager';
import ReviewCourseTerms from '../Common/ReviewCourseTerms';
import ReviewBatch from '../Admin/ReviewBatch';
import PrivateContentLayout from '../Common/PrivateContentLayout';
import StudentManager from '../Admin/StudentManager';
import ReviewStudent from '../Admin/ReviewStudent';
import TutorManager from '../Admin/TutorManager';
import ReviewTutor from '../Admin/ReviewTutor';
import TenantCMSMapping from '../Admin/TenantCMSMapping';
import GDriveSetupGuide from '../Admin/GDriveSetupGuide';
import QuestionSetCategoryManager from '../Admin/QuestionSetCategoryManager';
import QuestionSetManager from '../Admin/QuestionSetManager';
import ReviewQuestionSet from '../Admin/ReviewQuestionSet';
import ExamManager from '../Admin/ExamManager';
import ReviewExam from '../Admin/ReviewExam';
import EvaluateExamByAdmin from '../Admin/EvaluateExamByAdmin';
import AdminScoreViewAttempt from '../Admin/AdminScoreViewAttempt';

const AdminRouter = () => {


    return (
        <Box >

          {/* Sidebar with fixed width */}
            <AdminSideBar />
            <PrivateContentLayout>
          {/* Main content area with flexible width */}
          <Box overflowY="auto">
            <Routes>
              <Route path="/" element={<Navigate to="register-enrolled-student" />} />
              <Route path="register-enrolled-student" element={<RegisterEnrolledStudent />} />
              <Route path="register-enrolled-student/review-enrolment/:enrolment_id" element={<ReviewEnrolment />} />
              <Route path="course-manager" element={<CourseManager />} />
              <Route path="course-manager/review-course/:course_id" element={<ReviewCourseTerms />} />
              <Route path="user-management" element={<UserManagement />} />
              <Route path="batch-management" element={<BatchManagement />} />
              <Route path="batch-management/review-batch/:batch_id" element={<ReviewBatch />} />
              {/* <Route path="change-password" element={<ChangePassword />} /> */}
              <Route path="student-manager" element={<StudentManager />} />
              <Route path="student-manager/review-student/:student_id" element={<ReviewStudent />} />
              <Route path="tutor-manager" element={<TutorManager />} />
              <Route path="tutor-manager/review-tutor/:tutor_id" element={<ReviewTutor />} />
              <Route path="tenant-cms-mapping" element={<TenantCMSMapping />} />
              <Route path="gdrive-setup-guide" element={<GDriveSetupGuide />} />
              <Route path="question-set-category-manager" element={<QuestionSetCategoryManager />} />
              <Route path="question-set-manager" element={<QuestionSetManager />} />
              <Route path="question-set-manager/review-question-set/:question_set_id" element={<ReviewQuestionSet />} />
              <Route path="exam-manager" element={<ExamManager />} />
              <Route path="exam-manager/review-exam/:exam_id" element={<ReviewExam />} />
              <Route path="exam-manager/review-exam/:exam_id/override/:exam_attempt_id" element={<EvaluateExamByAdmin />} />
               <Route path="exam-manager/review-exam/:exam_id/score/:exam_attempt_id" element={<AdminScoreViewAttempt />} />
              
            </Routes>
          </Box>
          </PrivateContentLayout>
      </Box>
    );
  };

export default AdminRouter;
